import React, { useEffect } from "react";
import styles from "./MenuDrawer.module.css";

/**
 * Right-side slide-in menu drawer with backdrop.
 * Props:
 *  - isOpen: boolean
 *  - onClose: fn()
 *  - items: [{ id, label, icon?, onClick? }]
 *  - title: string
 */
export default function MenuDrawer({
  isOpen,
  onClose,
  items = [],
  title = "Menu",
}) {
  //#region Lifecycle: Escape key to close + prevent background scroll
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    if (isOpen) {
      document.addEventListener("keydown", handleKey);
      // lock background scroll while open
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.removeEventListener("keydown", handleKey);
        document.body.style.overflow = prevOverflow;
      };
    }
  }, [isOpen, onClose]);
  //#endregion

  //#region Render
  return (
    <div className={styles.root} data-open={isOpen} aria-hidden={!isOpen}>
      <div className={styles.backdrop} onClick={onClose} />
      <aside
        className={styles.panel}
        role="dialog"
        aria-modal="true"
        aria-labelledby="drawerTitle"
      >
        {/* Header */}
        <div className={styles.header}>
          <h2 id="drawerTitle" className={styles.title}>
            {title}
          </h2>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>

        {/* Menu items */}
        <nav className={styles.menu}>
          {items.map((item) => (
            <button
              key={item.id}
              className={styles.menuButton}
              onClick={() => {
                item.onClick?.();
                onClose?.();
              }}
              type="button"
            >
              <span className={styles.icon}>{item.icon ?? "•"}</span>
              <span className={styles.label}>{item.label}</span>
            </button>
          ))}
        </nav>
      </aside>
    </div>
  );
  //#endregion
}
